export default function XSLT_EditXML() {
  return (
    <div>
      <h1>XSLT_EditXML</h1>
      <p>This is the XSLT_EditXML component.</p>
    </div>
  );
}